import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import BDetailsPage from "../../../components/crud/BDetailsPage";
import BErrorIndicator from "../../../components/indicators/BErrorIndicator";
import BLoadingIndicator from "../../../components/indicators/BLoadingIndicator";
import { partnersService } from "../../../service/partnersService";


const PartnersDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [partner, setPartner] = useState(null);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    partnersService
      .getPartnerById(id)
      .then((res) => setPartner(res.data))
      .catch((err) => {
        if (err.response.status === 404) {
          history.push("/partners");
        }
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, [id]);

  const handleDelete = () => {
    partnersService.deletePartner(id);
    history.push("/partners");
  };

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  return <BDetailsPage data={partner} handleDelete={handleDelete} />;
};

export default PartnersDetails;
